import {
  kubeNamespaceFrontendPlugin,
  KubeNamespaceFrontendPage,
} from '@cfa/kss-backstage-plugin';
import {
  convertLegacyPageExtension,
  convertLegacyPlugin,
} from '@backstage/core-compat-api';

export const kubeSelfServePageModule = convertLegacyPlugin(
  kubeNamespaceFrontendPlugin,
  {
    extensions: [
      convertLegacyPageExtension(KubeNamespaceFrontendPage, {
        path: '/kube-self-serve',
        name: 'Kube Self-Serve',
      }),
    ],
  },
);